// Pull an 11-char video id from common YouTube URL shapes (watch?…v=, youtu.be/,
// embed/, v/, shorts/). Returns null for anything else.
export const getYoutubeId = (url) => {
  if (!url) return null;
  const match = String(url).match(
    /(?:youtu\.be\/|youtube\.com\/(?:watch\?(?:[^#]*&)?v=|embed\/|v\/|shorts\/))([A-Za-z0-9_-]{11})/,
  );
  return match ? match[1] : null;
};

// Public YouTube thumbnail for a video URL, or null when the URL isn't YouTube.
const getYoutubeThumbnail = (url) => {
  const id = getYoutubeId(url);
  return id ? `https://img.youtube.com/vi/${id}/mqdefault.jpg` : null;
};

export default getYoutubeThumbnail;
